import { Avatar, Button, Card, CardContent, Chip, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, Pagination } from "@mui/material";
import { useEffect, useState } from "react";
import { Box, TableContainer } from "@mui/material";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { usePostBodyWithJwtMutation } from "src/redux/api/cabinet";
import { palette } from "src/theme/style/palette";
import { ReturnNumber } from "src/components/return-balance/ReturnNumber";
import { Alerting } from "src/views/components_cabinet/Alerting";
import { SetPurchase } from "./SetPurchase";
import { RootState } from "src/redux";

dayjs.locale("ru");

export const P2pTable = () => {
    const [getAlert, setgetAlert] = useState<{ type: number; msg: string } | undefined>(undefined);
    const { } = useSelector((state: RootState) => state.app);
    const [rows, setRows] = useState<any[]>([]);
    const [activeRow, setActiveRow] = useState<any>(undefined);
    const nav = useNavigate();
    const [searchParams] = useSearchParams();
    const [stateModalPurchase, setStateModalPurchase] = useState<boolean>(false);

    const [lastPage, setLastPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [reload, setReload] = useState(false);

    const ownerFilter = searchParams.get("owner");
    const currencyFilter = searchParams.get("currency");
    const amountFilter = searchParams.get("amount");

    const [postData, { isSuccess, isLoading }] = usePostBodyWithJwtMutation();

    const registerAnswer = async (body: any) => {
        const route = "p2p-exchange";
        const jwt = localStorage.getItem("jwt");
        await postData({ body, route, jwt })
            .unwrap()
            .then((payload: any) => {
                setLastPage(payload.data?.last_page || 1);
                setCurrentPage(payload.data?.current_page || 1);
                const localRows = payload.data.data.map((e: any, i: number) => ({
                    iteration: i + 1,
                    ...e
                }));
                setRows(localRows);
            })
            .catch((error: any) => {
                if (error.status == 401) nav("/login");
                setgetAlert({ type: 2, msg: error.data.message });
            });
    };

    const requestExchanges = (page = 1) => {
        registerAnswer({
            owner: !ownerFilter || ownerFilter === 'false' ? false : true,
            currency: currencyFilter,
            amount: amountFilter,
            page,
        });
    }

    const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
        requestExchanges(value);
    };

    const handleReload = () => {
        setReload(!reload);
    }

    useEffect(() => {
        requestExchanges();
    }, [reload, searchParams]);

    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant="h6" mb={3}>
                        Все объявления
                    </Typography>

                    {isLoading && (
                        <Box
                            sx={{
                                minHeight: "30vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <CircularProgress sx={{ color: `${palette.blue} !important` }} />
                        </Box>
                    )}

                    {!isLoading && isSuccess && (
                        <>
                            <TableContainer
                                component={Paper}
                                sx={{ boxShadow: "none", overflowY: "auto", minHeight: "260px" }}
                            >
                                <Table sx={{ minWidth: 650 }} aria-label="p2p-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><Typography variant='h6'>№</Typography></TableCell>
                                            <TableCell><Typography variant='h6'>Продавец</Typography></TableCell>
                                            <TableCell><Typography variant='h6'>Сумма продажи</Typography></TableCell>
                                            <TableCell><Typography variant='h6'>Курс</Typography></TableCell>
                                            <TableCell><Typography variant='h6'>Название банка</Typography></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell><Typography variant='h6'>Опубликовано</Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.length > 0 ? (
                                            rows.map((row: any, i: number) => {
                                                return (
                                                    <TableRow
                                                        key={i}
                                                        sx={{
                                                            backgroundColor: i % 2 === 0 ? palette.lightWhiteBg : palette.blueLight,
                                                            transition: 'background-color 0.3s ease',
                                                            '&:hover': { backgroundColor: palette.blueLight },
                                                        }}
                                                    >
                                                        <TableCell>{i + 1}</TableCell>

                                                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                            <Box display="flex" alignItems="center">
                                                                <Avatar
                                                                    sx={{ mr: 1, "&>img": { objectFit: "cover" } }}
                                                                    alt={row.login}
                                                                    src={row?.avatar ? row.avatar : ""}
                                                                />
                                                                <Box>
                                                                    <Typography className="notranslate" sx={{ fontWeight: 500, fontSize: ".95rem" }}>
                                                                        {row?.login || "Логин не найден"}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </TableCell>

                                                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                            <Typography className="notranslate" variant="h6">
                                                                <ReturnNumber num={row.amount} />&nbsp; USDT
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                            <Typography className="notranslate" variant="h6">
                                                                {/* <ReturnNumber num={row.amount * row.co} />&nbsp;{row?.currency_id || "Неизвестно"} */}
                                                                {row.course}
                                                            </Typography>
                                                        </TableCell>

                                                        <TableCell>
                                                            <Chip sx={{ fontWeight: 600 }} label={row?.bank || "Неизвестно"} />
                                                        </TableCell>
                                                        <TableCell>
                                                            <Button variant="contained"

                                                                onClick={() => {
                                                                    setStateModalPurchase(true);
                                                                    setActiveRow(row);
                                                                }}>
                                                                Купить
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                            <Typography sx={{ fontWeight: 500 }}>
                                                                {row.created_at ? dayjs(row.created_at).format("DD MMM YYYY, HH:mm") : "Неизвестно"}
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell align="center" colSpan={7}>
                                                    <Typography variant="h6" textAlign="center">
                                                        Нет операций
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {lastPage > 1 &&
                                <Box my={1}>
                                    <Pagination
                                        count={lastPage}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                    />
                                </Box>
                            }

                        </>
                    )}
                </CardContent>
            </Card>

            <Dialog fullWidth={true} maxWidth="lg" open={stateModalPurchase} onClose={() => {
                setStateModalPurchase(false);
                setActiveRow(undefined);
                setReload(!reload);
            }}>
                <IconButton sx={{ background: palette.errorLight, position: 'absolute', top: '.5rem', right: '.5rem' }}
                    onClick={() => {
                        setStateModalPurchase(false);
                        setReload(!reload);
                    }}>
                    <CloseRoundedIcon sx={{ color: palette.error }} />
                </IconButton>
                <DialogTitle>Забронировать</DialogTitle>
                <DialogContent sx={{ position: 'relative' }}>
                    <Box display='flex' minHeight={360}>
                        {!activeRow ?
                            <Box display='flex' alignItems='center' justifyContent='center' width='100%'>
                                <Typography textAlign='center' variant="h5">Выберите объявление</Typography>
                            </Box>
                            :
                            <SetPurchase active={activeRow} reload={handleReload} />
                        }
                    </Box>
                </DialogContent>
            </Dialog>

            {getAlert && <Alerting get={getAlert} />}
        </>
    );
};